const styles = {
  container: {
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    padding: "24px",
    margin: "16px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom: "24px",
    padding: "20px",
  },
  title: {
    fontSize: "24px",
    fontWeight: 600,
  },
  listContainer: {
    marginTop: "14px",
  },
  emptyState: {
    textAlign: "center",
    padding: "32px 0",
    color: "#6B7280",
  },
  modalInput: {
    mt: 2,
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    my: 1
  },
  selectFY: {
    display: "flex",
    justifyContent: "center",
    my: "10px",
    height: "2.4em",
    fontSize: "14px",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "5.5px 14px",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0",
      height: "40px"
    },
    width: "300px",
  },
};

export default styles;

